/**
 * @voltxampere/ui — 7404 hex NOT inverter TTL variant (Sprint 41-4)
 *
 * Reference: TI SN5404. Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic7404 = {
    id: "7404",
    nameTr: "7404 (6'lı NOT, DIP-14)",
    nameEn: "7404 (Hex Inverter, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "7404",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        vHigh: 2.4,
        vLow: 0.4,
        threshold: 1.4,
        propagationDelay: 10e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-7404.js.map